import { render, staticRenderFns } from "./unallocatedTask.vue?vue&type=template&id=49dd4f34&"
import script from "./unallocatedTask.vue?vue&type=script&lang=js&"
export * from "./unallocatedTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports